export const sportbikes = [
  {
    id: 0,
    name: 'suzuki gxr',
    image: 'suzukigxr/1.png',
    info: {
      model: 2016,
      price: '230,000',
      color: 'blue/black',
      km: '30,000',
      mod: ['loweing kit', 'ecu flash', 'fourbrouhter exhausty'],
    },
    gallery: [
      'suzukigxr/1.png',
      'suzukigxr/2.png',
      'suzukigxr/3.png',
      'suzukigxr/4.png',
      'suzukigxr/5.png',
    ],
  },
  {
    id: 1,
    name: 'bmw s1000rr',
    image: 'bmws1000rr/1.png',
    info: {
      model: 2019,
      price: '330,000',
      color: 'blue/black',
      km: '30,000',
      mod: ['loweing kit', 'ecu flash', 'fourbrouhter exhausty'],
    },
    gallery: ['bmws1000rr/1.png', 'bmws1000rr/2.png', 'bmws1000rr/3.png'],
  },
  {
    id: 2,
    name: 'yamaha fz',
    image: 'yamahafz/1.png',
    info: {
      model: 2010,
      price: '140,000',
      color: 'blue/black',
      km: '20,000',
      mod: ['loweing kit', 'ecu flash', 'fourbrouhter exhausty'],
    },
    gallery: ['yamahafz/1.png', 'yamahafz/2.png', 'yamahafz/3.png'],
  },
  {
    id: 3,
    name: 'honda hornet',
    image: 'hondahornet/1.png',
    info: {
      model: 2008,
      price: '80,000',
      color: 'blue/black',
      km: '30,000',
      mod: ['loweing kit', 'ecu flash', 'fourbrouhter exhausty'],
    },
    gallery: ['hondahornet/1.png', 'hondahornet/2.png', 'hondahornet/3.png'],
  },
  {
    id: 4,
    name: 'honda repsol',
    image: 'hondarepsol/1.png',
    info: {
      model: 2012,
      price: '160,000',
      color: 'blue/black',
      km: '30,000',
      mod: ['loweing kit', 'ecu flash', 'fourbrouhter exhausty'],
    },
    gallery: ['hondarepsol/1.jpg', 'hondarepsol/2.jpg', 'hondarepsol/3.jpg'],
  },
  {
    id: 5,
    name: 'kawasaki ninja',
    image: 'kawasakininja/1.png',
    info: {
      model: 2018,
      price: '180,000',
      color: 'blue/black',
      km: '30,000',
      mod: ['loweing kit', 'ecu flash', 'fourbrouhter exhausty'],
    },
    gallery: [
      'kawasakininja/1.jpg',
      'kawasakininja/2.jpg',
      'kawasakininja/3.jpg',
    ],
  },
  {
    id: 6,
    name: 'yamaha r1',
    image: 'yamahar1/1.png',
    info: {
      model: 2016,
      price: '240,000',
      color: 'blue/black',
      km: '50,000',
      mod: ['loweing kit', 'ecu flash', 'fourbrouhter exhausty'],
    },
    gallery: ['yamahar1/1.jpg', 'yamahar1/2.jpg', 'yamahar1/3.jpg'],
  },
];
